import { render, staticRenderFns } from "./BuildingSectionEditModal.vue?vue&type=template&id=74e605b8&scoped=true&"
import script from "./BuildingSectionEditModal.vue?vue&type=script&lang=js&"
export * from "./BuildingSectionEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e605b8",
  null
  
)

export default component.exports